import MultiCurrency from "Modules/marketing/assets/multi-currency";

jQuery( document ).ready( function ( $ ) {
	window.elementorAddToCartTracking = {
		requiredSelector: 'a[href*="&edata="]',
		isString: function ( inputText ) {
			return typeof inputText === 'string' || inputText instanceof String;
		},
		getCurrency: async function () {
			if ( window.multiCurrencyDataV3 ) {
				const multiCurrency = new MultiCurrency();
				return await multiCurrency.getUserCurrency( window.multiCurrencyDataV3 );
			}
		},
		urlParam: function ( url, param ) {
			var results = new RegExp( '[\?&]' + param + '=([^&#]*)' ).exec( url );
			return results[ 1 ] || 0;
		},
		consts: {
			'brand': 'Elementor',
			'variant': 'N/A',
			'quantity': 1
		},
		onAddToCart: async function ( href ) {
			if ( !window.dataLayer || !dataLayer.push ) {
				return;
			}
			let data = window.elementorAddToCartTracking.urlParam( href, 'edata' );
			let product = Object.assign( JSON.parse( decodeURIComponent( data.replace( /\+/g, ' ' ) ) ), window.elementorAddToCartTracking.consts );
			const currency = await window.elementorAddToCartTracking.getCurrency();
			product.price = window.elementorAddToCartTracking.isString( product.price ) ? product.price : product.price[ currency ];
			let params = {
				'event': 'add_to_cart',
				'plan_sku': product.name,
				'ecommerce': {
					'currency': currency,
					'value': product.price,
					'items': [{
						'item_id': product.id,
						'item_name': product.name,
						'item_category': product.category,
						'price': product.price,
						'quantity': product.quantity,
					}],
				}
			};
			dataLayer.push( params );
		},
		init: function () {
			$( document.body ).on( 'click', window.elementorAddToCartTracking.requiredSelector, function ( e ) {
				const href = ( undefined !== e.target.href ) ? e.target.href : $( e.target ).closest( window.elementorAddToCartTracking.requiredSelector ).attr( 'href' );
				if ( undefined === href || null === href ) {
					return;
				}
				window.elementorAddToCartTracking.onAddToCart( href );
			} );
		}
	};
	window.elementorAddToCartTracking.init();
} );
